import React from 'react'

const WhyUsCard = ({ props }) => {
    return (
        <div>
        <div className="flex flex-col  bg-white rounded-[6px] my-5">
            <div className="">
                <img src={props.image} alt="" className="h-full rounded-t-[6px]" />
            </div>
            <div className="h-auto flex flex-col justify-between items-start  w-[90%]">
                <div className=" p-2 w-full">
                    <div className="font-poppins text-[14px] text-start font-[700]">
                        {props.heading}
                    </div>
                    <div className="font-poppins text-[12px] font-[300] my-3">
                        {props.desc}
                    </div>
                </div>
            </div>
            {/*<div className=" py-4">*/}
            {/*    <button*/}
            {/*        className="bg-white font-poppins text-[#1A76D1] text-[12px] font-[600] p-2 px-3 rounded-[6px] border border-[#1A76D1]"*/}
            {/*    >*/}
            {/*        Read More*/}
            {/*    </button>*/}
            {/*</div>*/}
        </div>
        </div>
    )
}

export default WhyUsCard
